<!--
 * @Author: wangyan1
 * @Description: 查看学员详情
 * @Date: 2022-05-06 15:35
 * @LastEditTime: 2022-05-06 15:35
 * @FilePath: /teacher-xkh-web/src/views/groupManage/components/viewReport.vue
-->
<template>
  <div class="view-report">
    <div class="qrcode">
      <div class="qrcode-body">
        <img :src="qrUrl" />
        <div class="qrcode-text">
          请使用 微信 扫码 分享给学员
        </div>
      </div>
      <i class="arrow" />
    </div>
    <div class="report-container">
      <iframe
        v-if="showReport"
        class="report-iframe"
        :src="newUrl"
        scrolling="yes"
        frameborder="0"
        width="100%"
        height="100%"
        id="iframe"
      />
    </div>
  </div>
</template>

<script>
import { getReportUrl } from '@/config/outsideUrl'
import QRCode from 'qrcode'
export default {
  name: 'ReportDetails',
  props: {
    reportParams: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      newUrl: '',
      qrUrl: '',
      showReport: false
    }
  },
  watch: {
    reportParams: {
      handler() {
        this.getStudyReport()
      },
      deep: true
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.getStudyReport()
    })
  },
  methods: {
    // 展示学习报告
    getStudyReport() {
      this.showReport = false
      const { userId, classTypeId, lessonId, checkSign, outputSource } = this.reportParams
      const url = getReportUrl({
        userId,
        classTypeId,
        lessonId,
        checkSign,
        outputSource
      })
      setTimeout(() => {
        this.newUrl = url + '&t=' + (new Date().getTime())
        this.initQrCode()
        this.showReport = true
      })
      console.log('展示学习报告', this.newUrl)
    },
    // 替换指定传入参数的值
    replaceParamVal (oUrl, paramName, replaceWith) {
      const re = new RegExp('(' + paramName + '=)([^&]*)', 'gi')
      const nUrl = oUrl.replace(re, paramName + '=' + replaceWith)
      return nUrl
    },
    /*
    * 生成二维码
    */
    initQrCode() {
      if (this.newUrl) {
        QRCode.toDataURL(this.newUrl)
          .then(url => {
            this.qrUrl = url
          })
          .catch(err => {
            console.error(err)
          })
      }
    }
  }
}
</script>

<style scoped lang="less">
@import '~@/static/css/base.less';
.view-report{
  width: 100%;
  height: 100%;
  .qrcode{
    width: 224px;
    height: 246px;
    background: #FFFFFF;
    border-radius: 8px;
    box-sizing: border-box;
    padding: 12px 16px;
    position: absolute;
    bottom: 28px;
    right: 891px;
    z-index: 1001;

    opacity: 0;
    animation: cssAnimation 0s 0.25s forwards;

    .arrow{
      display: inline-block;
      position: absolute;
      right: -3px;
      bottom: 6px;
      width: 20px;
      height: 32px;
      background: #FFF;
      transform: rotate(45deg);
      border-radius: 2px;
    }

    .qrcode-body{
      background: @gray-10;
      text-align: center;
      border-radius: 4px;
      height: 100%;
      width: 100%;
      z-index: 2;
      position: relative;
    }

    img{
      width: 200px;
      height: 200px;
      margin-left: -3px;
    }
    .qrcode-text{
      font-size: 14px;
      line-height: 18px;
      text-align: center;
      color: @gray-3;
    }
  }
}
.ant-drawer{
  :deep(.ant-drawer-body) {
    padding: 0;
  }

  .drawer-header{
    display: flex;
    font-size: 16px;
    color: @gray-2;

    .title-info{
      font-size: 14px;
      color: @gray-3;
      font-weight: 400;

      .ant-divider{
        margin: 0 16px;
      }
    }
  }

  .report-container{
    width: 100%;
    height: 100%;
    overflow-y: auto;
    display: flex;
  }

  &.group-drawer{
    .report-container{
      .report-iframe{
        width:776px;
      }
    }
  }
}
@keyframes cssAnimation {
    to {
     opacity: 1;
    }
}
</style>
